import { render, staticRenderFns } from "./SettingsModuleListItem.vue?vue&type=template&id=0790dd0a&"
import script from "./SettingsModuleListItem.vue?vue&type=script&lang=js&"
export * from "./SettingsModuleListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports